import React from "react";

/**
 * Shown when a client's subscription is suspended (canceled or unpaid after retries).
 * Deliberately generic — end users should not know why the site is down.
 */
export function SuspendedPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background text-foreground px-6 text-center">
      <h1 className="text-2xl font-display font-semibold">We'll be back soon.</h1>
      <p className="text-muted-foreground max-w-sm">
        This site is temporarily unavailable. Please check back later.
      </p>
    </div>
  );
}
